import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import apipath from '@constants/apipath'
import getSavedState from '../../utils/get-state'
import saveState from '../../utils/save-state'

export const state = {
  cached: [],
  lenderId: getSavedLenderState('lenders.lenderId'),
  selectedCustomerName: getSavedState('selectedCustomerName'),
}

export const getters = {
  products: (state) => {
    return state.products
  },
  productId: (state) => {
    return state.productId
  },
  selectedCustomerName: (state) => {
    return state.selectedCustomerName
  },
}

export const mutations = {
  SET_PRODUCT(state, productDetails) {
    state.products = productDetails
  },
  SET_PRODUCT_ID(state, productId) {
    state.productId = productId
  },
  SET_SELECTED_CUSTOMER_NAME(state, customerName) {
    state.selectedCustomerName = customerName
    saveState('selectedCustomerName', customerName)
  },
}

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  // TODO: Review later
  uploadProductImage({ commit }, { file, lenderID }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }

    var formData = new FormData()
    formData.append('file', file, 'image.jpg')
    formData.append('lenderID', lenderID)

    return axios
      .post(appConfig.adminApiUri + 'product/uploadimage/', formData, {
        headers: headers,
      })
      .then((response) => {
        return response
      })
    // .catch(function(error) {
    //   alert(error)
    // })
  },

  async fetchProductById({ commit }, { productID }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.getProductById}/${productID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        commit('SET_PRODUCT', response.data)

        return response.data
      })
      .catch((error) => {
        return error
      })
  },

  // TODO: Review later
  fetchProductsTotalRecords(
    { commit },
    { lenderId, pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    var id = lenderId !== '' ? lenderId : state.lenderId
    return axios
      .get(
        `${appConfig.adminApiUri}product/getproductstotalrecords/${id}?PageSize=${pageSize}&PageNumber=${pageNumber}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },

  // TODO: Review later
  downloadProductReport(
    { commit },
    { customerId, pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.downloadProducts}/${customerId}?PageNumber=${pageNumber}&PageSize=${pageSize}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        {
          headers: headers,
        }
      )
      .then(function(response) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = '\r\n' + response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, 'productReport.csv')
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'productReport.csv') // or any other extension
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
      .catch(function(error) {
        alert(error)
      })
  },

  async fetchProducts(
    { commit },
    { customerId, key, pageSize, pageNumber, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.getProducts}/${customerId}?PageNumber=${pageNumber}&PageSize=${pageSize}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
  },

  async fetchCustomerUser({ commit }, { customerId, roleId }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.getcustomerusersbyrole}?CustomerId=${customerId}&RoleId=${roleId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
  },

  async createProduct({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.createProduct}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
  },

  async updateProduct({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.updateProduct}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
  },

  async fetchProductsByUserId(
    { commit },
    { userId, pageSize = 15, pageNumber, key, value, sortBy, sortDirection }
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.getProductsByUserId}/${userId}?PageSize=${pageSize}&PageNumber=${pageNumber}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
  },

  async updateProductUrl({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.updateProductUrl}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
  },
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}

function getSavedLenderState(key) {
  if (window.localStorage['lenders'] !== 'undefined')
    return JSON.parse(window.localStorage.getItem(key))
  else return null
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
